import {
    GET_PROPERTY_DEVICES_SUCCESS,
    GET_PROPERTY_DEVICES_FAILURE,
    CHECK_DEVICE_EXISTS,
    SET_DEVICE_EXISTS_VALIDATION_RESULT
} from './types';

export const getPropertyDevicesSuccess = devices => {
    return {
        type: GET_PROPERTY_DEVICES_SUCCESS,
        payload: devices
    };
};

export const getPropertyDevicesFailure = error => {
    return {
        type: GET_PROPERTY_DEVICES_FAILURE,
        payload: error
    };
};

export const checkDeviceExists = (deviceNumber, facilityCode, ca4kInstance) => {
    return {
        type: CHECK_DEVICE_EXISTS,
        payload: { deviceNumber, facilityCode, ca4kInstance }
    };
};

export const setDeviceExistsValidationResult = (isValid, errorMessage) => {
    return {
        type: SET_DEVICE_EXISTS_VALIDATION_RESULT,
        payload: { isValid, errorMessage }
    };
};
